import axios from "axios"
import { kioskApiUrl } from "../../config/microservicesUrls"

const api_url = kioskApiUrl()

async function AxiosPost(jwt, endpoint, data) {
  const axiosObj = axios.create()

  let requestConfig = {
    headers: {
      Authorization: "Bearer " + jwt,
      "Content-Type": "application/json",
    },
  }

  let response = await axiosObj.post(
    `${api_url}${endpoint}`,
    data,
    requestConfig
  )
  return response.data
}

export async function getActivityList(jwt, params) {
  const endpoint = "/api/ActivityCheckIn/List"
  const payload = {
    organizationId: params.organizationId,
    startDateTime: params.startDateTime,
    endDateTime: params.endDateTime,
    participantIds: params.participantIds || [],
    pageSize: params.pageSize || 50,
    pageNum: params.pageNum || 1,
    organizationLocationId: params.organizationLocationId || null,
  }

  return await AxiosPost(jwt, endpoint, payload)
}
